exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1iUKVoMMMW0XT1E493sudB{color:#094ab2;font-size:18pt}._1n1-VSXuvigOWa-fe3rD8Y{color:#0061d5;font-size:24px}._3bf-Ra_RxzK1CJ2PddoTOI{color:#0071e0;font-size:18pt}.Kw_s2kKN9yB5s44PhsEZs{color:#4267b2;font-size:18pt}._23IY5HqKo80K2KE2kZUnzs{color:#00968f;font-size:18pt}html[dir] ._1nOWmKClsD9ikxMgv4k-kr{background-color:transparent}._1OzL8lUd5GiI5jGvlmwvUJ,._2T0Q-A-U9COnSlgfTRXCJZ,._2U2GOxOHDTnSIDdEQvSFaC{color:\"[theme:themePrimary, default:#0078D7]\";font-size:24px}._1XnwPFRMbhuhd9aqgUJbjN{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:18pt}._3f4jYRCgzQkfQoVjboALX1{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:24px}._1bfFjakYR3MMZfKb1g9rDu,._1EwzVNAucLtXS_62RggQgu,._3arkcTtsaEe9bsII4l-PKk,._3lPFqR9i3_-0ohWwTpZzog{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:18pt}._2gfZnPtVxDm88zc1tbXBYz,._3_s3U9UMbf72ysMG8tX2t1,._3Dg2CFPfVqJP9diDZQPhZo{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:24px}", ""]);

// exports
exports.locals = {
	"oneDriveIcon": "_1iUKVoMMMW0XT1E493sudB",
	"boxIcon": "_1n1-VSXuvigOWa-fe3rD8Y",
	"dropboxIcon": "_3bf-Ra_RxzK1CJ2PddoTOI",
	"facebookIcon": "Kw_s2kKN9yB5s44PhsEZs",
	"egnyteIcon": "_23IY5HqKo80K2KE2kZUnzs",
	"pngGoogleIcon": "_1nOWmKClsD9ikxMgv4k-kr",
	"recentAttachmentsIcon": "_2T0Q-A-U9COnSlgfTRXCJZ",
	"groupIcon": "_2U2GOxOHDTnSIDdEQvSFaC",
	"mailMessageIcon": "_1OzL8lUd5GiI5jGvlmwvUJ",
	"disabledOneDriveIcon": "_1XnwPFRMbhuhd9aqgUJbjN",
	"disabledBoxIcon": "_3f4jYRCgzQkfQoVjboALX1",
	"disabledDropboxIcon": "_1EwzVNAucLtXS_62RggQgu",
	"disabledFacebookIcon": "_1bfFjakYR3MMZfKb1g9rDu",
	"disabledGoogleDriveIcon": "_3lPFqR9i3_-0ohWwTpZzog",
	"disabledEgnyteIcon": "_3arkcTtsaEe9bsII4l-PKk",
	"disabledRecentAttachmentsIcon": "_2gfZnPtVxDm88zc1tbXBYz",
	"disabledGroupIcon": "_3_s3U9UMbf72ysMG8tX2t1",
	"disabledMailMessageIcon": "_3Dg2CFPfVqJP9diDZQPhZo"
};